import script from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=907694b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-907694b0"]])

export default __exports__